// extracted by mini-css-extract-plugin
export default {"stageSelect":"p3AyLvXdkEeFAQ9zFE_y__stageSelect___"};